const LoadingChat = () => (
  <div>
    <img
      className="h-14"
      src="https://static-media.gritworks.ai/fe-images/GIF/Shikshalokam/loading%20animation.gif"
    />
  </div>
);

export default LoadingChat;
